/*

  This component will lazy load a module component when it is to be rendered

*/
import React, { PureComponent } from "react"
import PropTypes from "prop-types"

import { BubblesLoader } from "ksc-portal-common-components/atoms"

class VerifiedAsyncComponent extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      Component: null,
    }
  }

  componentDidMount() {
    const { moduleProvider, register } = this.props

    moduleProvider
      .then(({ VerifiedRouter }) => {
        this.setState({ Component: VerifiedRouter(register) })
      })
      .catch(console.error)
  }

  render() {
    const { store, splashScreenFinished } = this.props
    const { Component } = this.state
    return splashScreenFinished ? (
      <div className="h-full">
        {Component ? (
          <Component store={store} />
        ) : (
          <BubblesLoader data-testid="verified-component-bubbles-loader" />
        )}
      </div>
    ) : null
  }
}

VerifiedAsyncComponent.propTypes = {
  moduleProvider: PropTypes.shape({
    then: PropTypes.func,
  }),
  register: PropTypes.func,
  store: PropTypes.shape({}).isRequired,
  splashScreenFinished: PropTypes.bool.isRequired,
}

VerifiedAsyncComponent.defaultProps = {
  moduleProvider: {},
  register: () => null,
}

export default VerifiedAsyncComponent
